// **********************************************************
// Hero Slider
// **********************************************************

// const heroMainSlider = document.querySelectorAll('[data-slider="hero-main-slider"]');
// const heroThumbSlider = document.querySelectorAll('[data-slider="hero-thumb-slider"]');

// const heroThumbSliderOptions = {
//   slidesPerView: 2.5,
//   spaceBetween: 8,
//   speed: 1000,
//   breakpoints: {
//     767: {
//       slidesPerView: 4,
//       spaceBetween: 16,
//     },
//   },
// };

// heroThumbSlider.forEach((el) => new Swiper(el, heroThumbSliderOptions));

// const heroMainSliderOptions = {
//   slidesPerView: 1,
//   spaceBetween: 0,
//   speed: 1500,
//   effect: 'fade',
//   fadeEffect: {
//     crossFade: true,
//   },
//   watchOverflow: true,
//   allowTouchMove: false,
//   autoplay: false,
// };

// heroMainSlider.forEach((el, i) => {
//   const mainSlider = new Swiper(el, heroMainSliderOptions);
//   const thumbSlider = new Swiper(heroThumbSlider[i], heroThumbSliderOptions);

//   mainSlider.controller.control = thumbSlider;

//   mainSlider.on('slideChange', () => {
//     const activeThumbIndex = mainSlider.realIndex;

//     const activeSlide = mainSlider.slides[mainSlider.activeIndex];
//     const videoEle = activeSlide.querySelector('video');
//     if (videoEle) {
//       videoEle.currentTime = 0;
//       videoEle.play();
//     }

//     // Remove active class from all slides
//     thumbSlider.slides.forEach((slide) => {
//       slide.classList.remove('swiper-slide-active');
//     });

//     // Add active class to the current slide
//     thumbSlider.slides[activeThumbIndex].classList.add('swiper-slide-active');
//     thumbSlider.slides[activeThumbIndex].style.setProperty('--animation-time', '7.5s');
//   });
// });
